import { createApiClient } from "./apiClientFactory";

export const useConsumerApi = () => {
    return createApiClient("consumer");
};
